<div class="p-6">
  <!-- Toast notifications -->
  <p-toast position="top-right"></p-toast>
  
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-heading-xl mb-2">
      {{ isEditMode ? ('userEdit.titleEdit' | translate) : ('userEdit.titleAdd' | translate) }}
    </h1>
    <p class="text-body-md text-secondary">
      {{ isEditMode ? ('userEdit.subtitleEdit' | translate) : ('userEdit.subtitleAdd' | translate) }}
    </p>
  </div>

  <!-- User Form -->
  <div class="max-w-2xl">
    <p-card>
      <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
        <!-- Email Field -->
        <div class="flex flex-col gap-2">
          <label for="email" class="text-label-md">{{ 'userEdit.email' | translate }}</label>
          @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
          } @else {
            <input
              id="email"
              type="email"
              pInputText
              [formControl]="emailControl"
              [placeholder]="'userEdit.emailPlaceholder' | translate"
              class="w-full"
            />
            @if (emailControl.invalid && emailControl.touched) {
              <p-message severity="error">
                {{ getEmailErrorMessage() }}
              </p-message>
            }
          }
        </div>

        <!-- Username Field -->
        <div class="flex flex-col gap-2">
          <label for="username" class="text-label-md">{{ 'userEdit.username' | translate }}</label>
          @if (loading()) {
            <p-skeleton width="100%" height="2.5rem"></p-skeleton>
          } @else {
            <input
              id="username"
              type="text"
              pInputText
              [formControl]="usernameControl"
              [placeholder]="'userEdit.usernamePlaceholder' | translate"
              class="w-full"
            />
            @if (usernameControl.invalid && usernameControl.touched) {
              <p-message severity="error">
                {{ getUsernameErrorMessage() }}
              </p-message>
            }
          }
        </div>

        <!-- Form Actions -->
        <div class="flex flex-col sm:flex-row gap-3 pt-4">
          @if (loading()) {
            <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
            <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
          } @else {
            <p-button
              type="submit"
              [label]="submitting() 
                ? (isEditMode ? ('userEdit.saving' | translate) : ('userEdit.creating' | translate))
                : (isEditMode ? ('userEdit.save' | translate) : ('userEdit.create' | translate))"
              [icon]="submitting() ? 'pi pi-spin pi-spinner' : (isEditMode ? 'pi pi-save' : 'pi pi-plus')"
              [disabled]="userForm.invalid || submitting()"
              [loading]="submitting()"
              class="flex-1 sm:flex-initial"
            />
            <p-button
              type="button"
              [label]="'userEdit.cancel' | translate"
              severity="secondary"
              [outlined]="true"
              [disabled]="submitting()"
              (onClick)="onCancel()"
              class="flex-1 sm:flex-initial"
            />
          }
        </div>
      </form>
    </p-card>
  </div>
</div>